// src/features/production/shortageHold/components/WorkOrderPicker.tsx

import { useWorkOrdersList } from "../api";

interface Props {
  value: string;
  onChange: (workOrderId: string) => void;
}

export function WorkOrderPicker({ value, onChange }: Props) {
  const { data: workOrders = [], isLoading } = useWorkOrdersList();

  return (
    <select
      aria-label="Work Order"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={isLoading}
      style={{
        width: "100%",
        padding: "10px 12px",
        borderRadius: "10px",
        border: "1px solid var(--color-border, #E4DCC8)",
        background: "#FFFFFF",
        color: "#2B2B2B",
        fontSize: "0.9rem",
        outline: "none",
      }}
    >
      <option value="">{isLoading ? "در حال بارگذاری..." : "انتخاب Work Order"}</option>
      {workOrders.map((wo) => (
        <option key={wo.id} value={wo.id}>
          {wo.sequence_no != null
            ? `WO #${wo.sequence_no} — ${wo.production_order_display ?? wo.id.slice(0, 8)}`
            : `WO: ${wo.id.slice(0, 12)}...`}
        </option>
      ))}
    </select>
  );
}
